import { render, staticRenderFns } from "./SModalCentered.vue?vue&type=template&id=0bd0650e&scoped=true"
import script from "./sModalCentered.ts?vue&type=script&lang=ts&external"
export * from "./sModalCentered.ts?vue&type=script&lang=ts&external"
import style0 from "./SModalCentered.vue?vue&type=style&index=0&id=0bd0650e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd0650e",
  null
  
)

export default component.exports